import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

/**
 * 清理本地数据缓存
 * @returns Promise<boolean>
 */
export const clearStorage = () => {
  return new Promise<boolean>((resolve, reject) => {
    core.call<'fabric_storage.clearStorage', null, boolean>(
      'fabric_storage.clearStorage',
      null,
      (result) => {
        const fabricErrors = filterFabricErrors(
          result.code,
          result.message,
          result.data
        );
        if (fabricErrors) {
          reject(fabricErrors);
        } else {
          resolve(result.data);
        }
      }
    );
  });
};
